import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api.js';

/**
 * Demande d'un lien de réinitialisation.
 *
 * Le message de confirmation est volontairement le même que l'adresse existe
 * ou non : le serveur ne le dit pas, et l'écran ne doit pas le trahir non plus.
 */
export function MotDePasseOublie() {
  const [email, setEmail] = useState('');
  const [envoye, setEnvoye] = useState(false);
  const [erreur, setErreur] = useState(null);
  const [envoi, setEnvoi] = useState(false);

  async function soumettre(evenement) {
    evenement.preventDefault();
    setErreur(null);
    setEnvoi(true);

    try {
      await api.post('/auth/forgot', { email });
      setEnvoye(true);
    } catch (echec) {
      setErreur(echec.message);
    } finally {
      setEnvoi(false);
    }
  }

  return (
    <main className="page page--etroite">
      <section className="verre">
        <h1>Mot de passe oublié</h1>

        {envoye ? (
          <>
            <p>
              Si un compte existe pour cette adresse, un lien de réinitialisation
              vient d’être envoyé. Il est valable une heure et ne fonctionne
              qu’une fois.
            </p>
            <p className="aide">
              Pensez à regarder dans les indésirables. Si rien n’arrive, c’est
              peut-être que ce compte se connecte avec Google — auquel cas il n’a
              pas de mot de passe.
            </p>
            <p className="bascule">
              <Link to="/connexion">Retour à la connexion</Link>
            </p>
          </>
        ) : (
          <>
            <p>
              Indiquez votre adresse : nous vous enverrons un lien pour choisir un
              nouveau mot de passe.
            </p>

            <form onSubmit={soumettre} noValidate>
              <div className="champ">
                <label htmlFor="email">Adresse email</label>
                <input
                  id="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {erreur && (
                <p className="erreur" role="alert">
                  {erreur}
                </p>
              )}

              <button className="bouton" type="submit" disabled={envoi}>
                {envoi ? 'Envoi…' : 'Envoyer le lien'}
              </button>
            </form>

            <p className="bascule">
              <Link to="/connexion">Retour à la connexion</Link>
            </p>
          </>
        )}
      </section>
    </main>
  );
}
